import type { EditorOpenAction } from '@/msgdeskRuntime/contracts/editorActions'

export const editorRouteSegments = ['new', 'new_msg', 'edit'] as const

export type EditorRouteMode = 'new_msg' | 'update_msg'
export type { EditorOpenAction } from '@/msgdeskRuntime/contracts/editorActions'

const editorModeBySegment: Record<(typeof editorRouteSegments)[number], EditorRouteMode> = {
  new: 'new_msg',
  new_msg: 'new_msg',
  edit: 'update_msg',
}

export function editorModeFromSegment(segment: string): EditorRouteMode | undefined {
  return editorModeBySegment[segment as keyof typeof editorModeBySegment]
}

export function editorSegmentForMode(mode: EditorRouteMode): 'new' | 'edit' {
  return mode === 'update_msg' ? 'edit' : 'new'
}

export function editorOpenActionForMode(mode: EditorRouteMode): EditorOpenAction {
  return mode === 'update_msg' ? 'open-edit-message' : 'open-new-message'
}

export function isEditorRouteSegment(segment: string): boolean {
  return editorModeFromSegment(segment) !== undefined
}
